import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanDeactivate } from '@angular/router';
import { OffersComponent } from './features/admin/offers/offers.component';
import { OfferDetailsComponent } from './features/admin/offers/offer-details/offer-details.component';
import { PagesComponent } from './features/admin/pages/pages.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { CustomerLayoutComponent } from './layout/customer-layout/customer-layout.component';
import { AuthComponent } from './features/auth/auth.component';
import { AuthGuard } from './interceptors/can-activate-interceptor';
import { EmptyComponent } from './layout/empty/empty.component';
import { LoginComponent } from './features/login/login.component';
import { LogoutComponent } from './features/logout/logout.component';
import { PageFormComponent } from './features/customer/page-form/page-form.component';
import { PageConfigComponent } from './features/admin/pages/page-config/page-config.component';
import { PageResolverComponent } from './features/page-resolver/page-resolver.component';
import { RoleType } from './shared/enums/role-type/role-type.module';
import { SsoComponent } from './features/sso/sso.component';
import { ConfirmDeactivateGuard } from './guards/confirm-deactivate/confirm-deactivate.guard';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    data: { role: RoleType.ADMIN },
    children: [
      { path: '', redirectTo: '/', pathMatch: 'full', data: { title: 'Redirect'} },
      { path: 'offers', component: OffersComponent, data: { title: 'Offers'} },
      { path: 'offers/:id', component: OfferDetailsComponent, data: { title: 'Offer'}},
      { path: 'pages', component: PagesComponent, data: { title: 'Pages'}},
      { path: 'pages/:id', component: PageConfigComponent, data: { title: 'Page'}, canDeactivate: [ConfirmDeactivateGuard] }
    ],
  },
  {
    path: 'customer',
    canActivate: [AuthGuard],
    component: CustomerLayoutComponent,
    children: [
      {
        path: ':customerId',
        component: PageResolverComponent,
        data: { title: 'Redirect'}
      },
      {
        path: ':customerId/page/:pageId',
        component: PageFormComponent,
        data: {
          customerId: 'customerId',
          pageId: 'pageId',
          title: 'Mon cahier des charges'
        }
      },
      {
        path: ':customerId/page/:pageId/preview',
        component: PageFormComponent,
        data: {
          customerId: 'customerId',
          pageId: 'pageId',
          title: 'Preview'
        }
      }
    ],
  },
  {
    path: '',
    data: { title: 'SOLOCAL - Mon cahier des charges' },
    children: [
      { path: '', component: EmptyComponent },
      { path: 'sso', component: SsoComponent },
      { path: 'auth', component: AuthComponent },
      { path: 'login', component: LoginComponent },
      { path: 'logout', component: LogoutComponent }
    ]
  },
  { path: '**', redirectTo: (location.pathname.toLowerCase())}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
